import { defineElement, FC, onDidLoad, useElement, useListen } from '@atomify/hooks';
import { isLoggedIn, login, userStore } from '@store/user';

const VkkOverlay: FC = () => {
    let href = '';

    const button = useElement<HTMLButtonElement>('[js-hook-button-submit]');

    onDidLoad(() => {
        userStore.subscribe(redirect, ['loggedIn']);
    });

    function redirect() {
        window.location.href = href;
    }

    useListen(button, 'click', onClick);

    function onClick(e: any) {
        e.preventDefault();
        href = e.currentTarget;

        if (!isLoggedIn()) {
            login();
        } else {
            redirect();
        }
    }
};

defineElement('bpd-vkk-overlay', VkkOverlay);
